/*global
    jQuery
*/
(function ($) {

	//$(document).ready(function() {
	//	if (typeof $('div.edit-pet-dash') !== 'undefined' && $('div.edit-pet-dash').length > 0) {
	//		var hash = location.hash;
	//		if (typeof hash !== 'undefined' && hash !== '') {
	//			$('html, body').animate({ scrollTop: $(hash).offset().top });
	//		}
	//	}
	//});

	$('li.nav-submenu-item > a').on('click', function(e) {
		var currentPath = location.pathname;
		var $link = $(this);
		var href = $link.attr('href');
		if (typeof currentPath !== 'undefined' && currentPath.startsWith('/mypets/edit-pets') && href.includes('/mypets/edit-pets')) {
			e.preventDefault();
			$('html, body').animate({ scrollTop: $(hash).offset().top });
			return false;
		}
	});
}(jQuery));
